import React from 'react';
import { Button } from 'antd';
import 'antd/dist/antd.css';
import { Link, RouteComponentProps } from 'react-router-dom';
import { FaUserEdit, FaUserMinus } from 'react-icons/fa';
export interface IOptionsProps {
  props: RouteComponentProps<{ id: string; ecoleid: string }>;
}

export const EleveOptions: React.FC<IOptionsProps> = ({ props }) => {
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;

  return (
    <>
      <h4 className="pt-4">Options</h4>
      <Button type="primary" style={{ borderRadius: 16 }}>
        <Link to={`/eleve/${ecoleId}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserEdit title="editer" />
          &nbsp; Modifier
        </Link>
      </Button>
      <Button style={{ marginTop: 5, backgroundColor: '#dc3545', color: 'white', borderRadius: 16 }}>
        <Link to={`/eleve/${ecoleId}/${id}/delete`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserMinus title="delete" />
          &nbsp; Supprimer
        </Link>
      </Button>
    </>
  );
};

export default EleveOptions;
